import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue'),
  },
  {
    path: '/lego',
    name: 'lego',
    component: () => import(/* webpackChunkName: "lego" */ '../views/Lego.vue'),
  },
  {
    path: '/lego/pieces',
    name: 'lego-pieces',
    component: () => import(/* webpackChunkName: "lego-pieces" */ '../views/lego/CategoryList.vue'),
  },
  {
    path: '/lego/pieces/category/:type',
    name: 'lego-pieces-category',
    component: () => import(/* webpackChunkName: "lego-pieces-category" */ '../views/lego/CategoryView.vue'),
    props: true,
  },
  {
    path: '/lego/pieces/:id(\\d+)',
    name: 'lego-piece-details',
    component: () => import(/* webpackChunkName: "lego-piece-details" */ '../views/lego/PieceDetails.vue'),
    props: true,
  },
  {
    path: '/lego/pieces/container-visualization',
    name: 'lego-container-visualization',
    component: () => import(/* webpackChunkName: "lego-container-visualization" */ '../views/lego/ContainerVisualization.vue'),
  },
  {
    path: '/currencies',
    name: 'currencies',
    component: () => import('../views/Currencies.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
